module.exports = __webpack_public_path__ + "static/an-abstract-poem-of-freedom-with-soldiers_2009-31efcb06d7ce4f084f78dbfad4961379.jpg";